import React, { useState } from 'react'
import SupabaseLoginForm from './SupabaseLoginForm'
import SupabaseRegisterForm from './SupabaseRegisterForm'

const SupabaseAuthPage = ({ onBackToGame }) => {
  const [isLogin, setIsLogin] = useState(true)

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '10px',
        boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
        maxWidth: '500px',
        width: '100%',
        position: 'relative'
      }}>
        {/* Header */}
        <div style={{
          background: '#1976d2',
          color: 'white',
          padding: '20px',
          borderRadius: '10px 10px 0 0',
          textAlign: 'center'
        }}>
          <h1 style={{ margin: 0, fontSize: '24px' }}>TopGammon</h1>
          <p style={{ margin: '5px 0 0 0', opacity: 0.9 }}>The Chess.com of Backgammon</p>
        </div>

        {/* Back to Game Button */}
        <button
          onClick={onBackToGame}
          style={{
            position: 'absolute',
            top: '20px',
            left: '20px',
            background: 'rgba(255,255,255,0.2)',
            border: '1px solid rgba(255,255,255,0.3)',
            color: 'white',
            padding: '8px 16px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          ← Back to Game
        </button>

        {/* Auth Form */}
        {isLogin ? (
          <SupabaseLoginForm 
            onSwitchToRegister={() => setIsLogin(false)} 
            onBackToGame={onBackToGame}
          />
        ) : (
          <SupabaseRegisterForm 
            onSwitchToLogin={() => setIsLogin(true)} 
            onBackToGame={onBackToGame}
          />
        )}
      </div>
    </div>
  )
}

export default SupabaseAuthPage 